export enum TreatmentType {
  Fillers = 'Fillers',
  Toxins = 'Toxins',
  Coolsculpting = 'Coolsculpting',
  CoolTone = 'CoolTone',
  Deoxycholate = 'Deoxycholate',
}
